
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 112 91"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#E0E4EC","d":"M6 .5A5.5 5.5 0 00.5 6v79A5.5 5.5 0 006 90.5h100a5.5 5.5 0 005.5-5.5V6A5.5 5.5 0 00106 .5H6z"}}),_c('path',{attrs:{"stroke":"#C1C8D6","stroke-linecap":"square","d":"M16 18.5V75"}}),_c('path',{attrs:{"stroke":"#1CD8AA","stroke-linecap":"round","stroke-width":"2","d":"M17 22.5h65"}}),_c('path',{attrs:{"stroke":"#FF4F72","stroke-linecap":"round","stroke-width":"2","d":"M17 31.5h9"}}),_c('path',{attrs:{"stroke":"#FFA725","stroke-linecap":"round","stroke-width":"2","d":"M17 42.5h49.521M17 51.5h39.5M17 62.5h29.521"}}),_c('path',{attrs:{"stroke":"#FF4F72","stroke-linecap":"round","stroke-width":"2","d":"M17 71.5h9.5"}})])])
          )
        }
      }
    